<template>
  <div v-if="list.length">
    <template v-for="item in list">
      <component
        :is="item.component"
        :key="item.id"
        :ref="item.id"
        v-bind="item.props"
      ></component>
    </template>
  </div>
</template>
<script>
  import isFunction from 'lodash/isFunction';
  import { NavigationContextManager } from '@/shared/utils/accessibility';

  export default {
    data() {
      return {
        list: [],
      };
    },
    created() {
      this.$modal.setInstance(this);
    },
    beforeDestroy() {
      this.$modal.setInstance(undefined);
    },
    methods: {
      create(modal) {
        if (isFunction(modal.component)) {
          Object.assign(modal, { component: modal.component() });
        }

        if (modal.component instanceof Promise) {
          return modal.component.then((component) => {
            Object.assign(modal, { component: component.default || component });
            return this.resolve(modal);
          });
        }

        return this.resolve(modal);
      },
      resolve({ id, component, props }) {
        this.list.push({ id, component, props });

        return this.$nextTick().then(() => {
          const modal = this.get(id);

          modal.$on('destroy', () => this.remove(id));
          modal.show();
          this.$nextTick(() => NavigationContextManager.pushContext(modal.$el, () => this.remove(id)));

          return modal;
        });
      },
      get(id) {
        const [ref] = this.$refs[id];

        return ref;
      },
      remove(id) {
        const item = this.list.find((item) => item.id === id);

        if (item) {
          this.list.splice(this.list.indexOf(item), 1);
        }

        NavigationContextManager.popContext();
      },
    },
  };
</script>
